export const navigation = [
  { name: 'Inicio', href: '/' },
  { name: 'Servicios', href: '/', section: 'servicios' },
  { name: 'Negocios', href: '/afiliate' },
  { name: 'Restaurantes', href: '/restaurantes' },
  { name: 'Ser Driver', href: '/quiero-ser-driver' },
  { name: 'Contacto', href: '/contacto' },
];
